import {
  Input,
  Output,
  OnInit,
  Component,
  EventEmitter,
  AfterViewInit,
  ChangeDetectionStrategy,
} from '@angular/core';

import { DataObject } from 'src/app/core/models/core.models';
import { SameFeedOperation } from 'src/app/core/models/widget-operations';

@Component({
  selector: 'app-move-copy-same-feed',
  templateUrl: './move-copy-same-feed.component.html',
  styleUrl: './move-copy-same-feed.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class MoveCopySameFeedComponent implements OnInit, AfterViewInit {
  @Input() widgets: DataObject[] = [];
  @Input() currentObject?: DataObject;
  @Output() formValidityChange = new EventEmitter<boolean>();

  constructor() {}

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    // * always valid since it's just a confirmation list
    setTimeout(() => {
      this.formValidityChange.emit(true);
    });
  }

  getFormData(): SameFeedOperation[] {
    if (!this.currentObject) return [];

    return this.widgets.map((widget) => ({
      scenario: 'same-feed',
      widget_id: widget.id,
      source_object_id: this.currentObject!.id,
      source_object_class_id: this.currentObject!.object_class_id,
      target_object_ids: [this.currentObject!.id],
      target_object_class_id: this.currentObject!.object_class_id,
      action: 'copy' as const,
      switch_datasource: false,
    }));
  }
}
